// Import dependencies
import { initialiser } from '../../ramen-imports/utilitybelt';

const defaultSettings = {
  activeClass: 'is-active',
};

class SideImages {
  constructor(config) {
    const { el, settings } = config;

    // Set root element
    this.container = el;

    // Set module dom sub elements e.g.
    this.images = [...el.querySelectorAll(settings.images)];
    this.totalImages = this.images.length;
    this.sideContent = document.querySelector(settings.sideContent);

    // Set settings
    this.settings = { ...defaultSettings, ...settings };
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.container || !this.images.length || !this.sideContent) return;

    this.images[0].classList.add(this.settings.activeClass);

    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    window.addEventListener('scroll', this.handleScroll);
  };

  handleScroll = () => {
    const verticalScrolled = window.pageYOffset;
    const sideContentHeight = this.sideContent.scrollHeight;
    const screenHeight = document.documentElement.clientHeight;
    // Scroll distance for each image
    const scrollDistance = Math.floor((sideContentHeight - screenHeight) / this.totalImages);
    // Transition duration for images
    const transitionDuration = Math.floor(sideContentHeight / screenHeight) + (this.totalImages - 1);
    let increment = scrollDistance;

    if (this.totalImages <= 1 || sideContentHeight < screenHeight) return;

    this.images.forEach((image, index) => {
      if (index < 1) return;

      if (verticalScrolled >= increment) {
        image.classList.add(this.settings.activeClass);
        image.style.transitionDuration = `${transitionDuration}00ms`; // eslint-disable-line
        increment += scrollDistance;
      } else {
        image.classList.remove(this.settings.activeClass);
      }
    });
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, SideImages);
